import * as React from 'react';

import { fetchForecastAccess, fetchForecastEnabled } from '@src/api/actions/dashboard/forecast';

/**
 * Should the client nav show the Forecast link? Only once staff have switched
 * the forecast on for the member's client. Staff previewing as a client
 * (``previewClientId``) read the same switch through the staff access endpoint,
 * since the "enabled" check always answers yes for staff.
 */
export default function useForecastNavEnabled(user, previewClientId = null) {
  const [enabled, setEnabled] = React.useState(false);
  const isStaff = Boolean(user?.is_staff || user?.is_superuser);
  const memberClientId = !isStaff ? user?.client_memberships?.[0]?.client_id : null;
  const clientId = isStaff ? previewClientId : memberClientId;

  React.useEffect(() => {
    if (!clientId) {
      setEnabled(false);
      return undefined;
    }
    let active = true;
    const req = isStaff
      ? fetchForecastAccess({ client_id: clientId })
      : fetchForecastEnabled({ client_id: clientId });
    req
      .then((resp) => active && setEnabled(Boolean((resp?.data || resp)?.enabled)))
      .catch(() => active && setEnabled(false));
    return () => {
      active = false;
    };
  }, [clientId, isStaff]);

  return enabled;
}
